import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { BusService } from "../bus.service";
import {
  IPostOptions,
  RequestService
} from "../request.service";
import { EventsService } from "../events.service";

interface IPostSendResetEmailRequest {
  email: string;
}

interface IPostSendResetEmailResponse {
  success: boolean;
}

@Injectable()
export class ForgotPasswordService {
  private options: IPostOptions<IPostSendResetEmailRequest,
                              IPostSendResetEmailResponse>;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private requestService: RequestService
  ) {
    this.options = {
      uri: "/account/send-password-reset-email",
      body: {
        email: "",
      },
      handlers: {
        success: this.success.bind(this),
        error: this.error.bind(this)
      }
    };
    this.subscribe();
  }

  public success(data: IPostSendResetEmailResponse): void {
    this.bus.publish(this.events.received.action.resetPasswordEmail.success);
  }

  public error(httpErrorResponse: HttpErrorResponse): void {
    this.bus.publish(this.events.received.action.resetPasswordEmail.failure);
  }

  public request(data: any): void {
    this.bus.publish(this.events.notified.request.starting);
    this.options.body.email = data.email;
    this.requestService.post<IPostSendResetEmailRequest,
                            IPostSendResetEmailResponse>(this.options);
  }

  private subscribe(): void {
    this.bus.subscribe(this.events.requested.action.resetPasswordEmail, this.request.bind(this));
  }
}
